import styled from 'styled-components';
import themeData from 'utils/theme/themeData';

const { typography } = themeData;

export const LoaderWrapper = styled.div`
  display: flex;
  flex-grow: 1;
  align-items: center;
  justify-content: center;
  height: calc(100vh - 56px);
`;

export const UpdateProfileWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  height: calc(100% - 131px);
  min-height: calc(100vh - 131px);
  padding: 24px 24px 51px;
  background-color: ${({ theme }) => theme.colors.grey100};
`;

export const NoResultsWrapper = styled.div`
  flex-grow: 1;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: ${({ theme }) => theme.colors.white};
  border-bottom-right-radius: 8px;
  border-bottom-left-radius: 8px;
`;

export const NoResultsText = styled(typography.TitleOneRegularTypography)``;

export const FormWrapper = styled.div`
  width: 60%;
  padding: 30px 0;
  background-color: white;
  border-radius: 8px;
`;

export const FormTitle = styled(typography.TitleOneRegularTypography)`
  margin: 0;
  padding: 0 25px;
  color: ${({ theme }) => theme.colors.black};
`;

export const FormGrid = styled.div`
  display: grid;
  grid-template: 1fr / 1fr 1fr;
  gap: 20px;
  padding: 0 25px;
`;

export const FormFieldWrapper = styled.div`
  ${({ fullWidth }) =>
    fullWidth &&
    `
    grid-column: 1/3;
  `}

  ${({ center }) =>
    center &&
    `
    text-align: center;
`}
`;

export const FormLabel = styled(typography.TitleTwoTypography)`
  margin: 0;
`;

export const FormTextInput = styled.input`
  width: 100%;
  height: 36px;
  padding: 8px 15px;
  font-size: 13px;
  line-height: 20px;
  color: ${({ theme }) => theme.colors.black};
  border: 1px solid ${({ theme }) => theme.colors.grey006};
  border-radius: 4px;
  box-sizing: border-box;

  ::-webkit-input-placeholder {
    font-size: 13px;
    line-height: 20px;
    color: ${({ theme }) => theme.colors.grey002};
  }
  ::-moz-placeholder {
    font-size: 13px;
    line-height: 20px;
    color: ${({ theme }) => theme.colors.grey002};
  }
  :-ms-input-placeholder {
    font-size: 13px;
    line-height: 20px;
    color: ${({ theme }) => theme.colors.grey002};
  }
  :-moz-placeholder {
    font-size: 13px;
    line-height: 20px;
    color: ${({ theme }) => theme.colors.grey002};
  }

  &:focus {
    border: 1px solid ${({ theme }) => theme.colors.grey006};
    outline: none;
  }
`;

export const FormTextAreaInput = styled.textarea`
  width: 100%;
  height: 100px;
  padding: 8px 15px;
  font-size: 13px;
  line-height: 20px;
  color: ${({ theme }) => theme.colors.black};
  border: 1px solid ${({ theme }) => theme.colors.grey006};
  border-radius: 4px;
  box-sizing: border-box;
  resize: none;

  ::-webkit-input-placeholder {
    font-size: 13px;
    line-height: 20px;
    color: ${({ theme }) => theme.colors.grey002};
  }
  ::-moz-placeholder {
    font-size: 13px;
    line-height: 20px;
    color: ${({ theme }) => theme.colors.grey002};
  }
  :-ms-input-placeholder {
    font-size: 13px;
    line-height: 20px;
    color: ${({ theme }) => theme.colors.grey002};
  }
  :-moz-placeholder {
    font-size: 13px;
    line-height: 20px;
    color: ${({ theme }) => theme.colors.grey002};
  }

  &:focus {
    border: 1px solid ${({ theme }) => theme.colors.grey006};
    outline: none;
  }
`;

export const FormImage = styled.img`
  width: 150px;
  height: 150px;
  border-radius: 50%;
`;

export const FormValidationError = styled(typography.BodyTextOneRegularTypography)`
  margin: 0;
  color: ${({ theme }) => theme.colors.redDark};
  ${({ centerText }) => centerText && 'text-align: center;'}
`;

export const FormBtnWrapper = styled.div`
  display: flex;
  justify-content: center;
`;

export const FormBtn = styled(typography.BodyTextOneRegularTypography)`
  padding: 8px 16px;
  color: ${({ theme }) => theme.colors.white};
  background-color: ${({ theme }) => theme.colors.primaryMain};
  border: 0px;
  border-radius: 4px;
  cursor: pointer;
`;
